import React,{useState, useEffect, Fragment} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import RichTextEditor from "@mantine/rte";
import { ButtonGroup,DatePicker as DatePickers, Dropdown, Input, Button, Panel, Steps, Checkbox, InputGroup, Tooltip, Whisper, InputNumber  } from "rsuite";
import moment from "moment";
import { Grid, Radio, Card } from "@nextui-org/react";
import { DatePicker, message, Space } from "antd";
import 'antd/dist/antd.css';
import { api, WorkshopListURL } from "../../../apis/urls";

const { MonthPicker, RangePicker } = DatePicker;



const ImageUpload =({indexValue, inputField, setDisabled})=>{


    
    const [fileUp, setFileUp] = useState('');

	const  changeHandler=(event)=>{

        console.log("index index", indexValue)
        setDisabled(true)
		// setFileSelect(event.name)

		let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

			console.log("respooonse", response.data)
			setFileUp(response.data.Location)
            inputField.image = response.data.Location
            inputField.key = response.data.Key
            setDisabled(false)

            console.log(inputField)

        }).catch((error) =>{     
            console.log('error',error.message)  
        });

	}



    return(

        <Fragment>



                <div className="col-md-6"  style={{marginTop:'20px'}}>
                    <label>Upload Image</label>  
                    <input 
                        // disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                        className='form-control public_input'
                        id="image"
                        name="image"
                        type="file"
                        // value={inputField.image}
                        onChange={(event)=>{changeHandler(event.target.files[0]);}} 
                    />

                </div>
        </Fragment>

    )

}





const DatePickerss =({indexValue, inputField})=>{


    const startDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        inputField.start_date = e
        // console.log(inputField)
      };

      const endDatePick = (e) => {
        // console.log('Selected Time: ', moment(e).format('YYYY-MM-DD HH:mm'));
        inputField.end_date = e

      };




    return(

        <Fragment>



                <div className="col-md-6"   style={{marginTop:'20px'}}>
                    <label>Start Date & Time</label>  
                    <DatePicker
                    // disabledDate={moment('2022-10-10 10:11').format('YYYY-MM-DD HH:mm')}
                    placeholder="Start Date (MM-DD-YYYY)"
                    className="workshop-dates"
                    showTime={{ format: 'hh:mm a' }}
                    format="MM-DD-YYYY hh:mm a"
                    style={{width:"100%"}} onChange={(e)=>{startDatePick(e)}} />
                </div>
                <div className="col-md-6"   style={{marginTop:'20px'}}>
                    <label>End Date & Time</label>  
                    <DatePicker 
                    placeholder="End Date (MM-DD-YYYY)"
                    className="workshop-dates"
                    format="MM-DD-YYYY hh:mm a"
                    style={{width:"100%"}} showTime onChange={(e)=>{endDatePick(e)}} />
                </div>
        </Fragment>

    )

}






const MultipleWorkshopCreate = () => {
    



    const [topicErr, setTopicErr] = useState(false)
    const [seatErr, setSeatErr] = useState(false)
    const [wnoErr, setWnoErr] = useState(false)
    const [pnameErr, setPnameErr] = useState(false)
    const [ptitleErr, setPtitleErr] = useState(false)
    const [porgErr, setPorgErr] = useState(false)

    const [topicErrInd, setTopicErrInd] = useState("")
    const [seatErrInd, setSeatErrInd] = useState("")
    const [wnoErrInd, setWnoErrInd] = useState("")
    const [pnameErrInd, setPnameErrInd] = useState("")
    const [ptitleErrInd, setPtitleErrInd] = useState("")
    const [porgErrInd, setPorgErrInd] = useState("")

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');



    const [editable, setEditable] = useState('done')
    const [editableIndex, setEditableIndex] = useState('')

    const [storeIndex, setStoreIndex] = useState('')

    const [disabled, setDisabled] = useState(false)


    const [inputFields, setInputFields] = useState([
        {topic:'',description: '', max_seats: '',workshop_no:'',presenter_name: '', presenter_title: '', presenter_organization:'', image: '', key:'', start_date:'', end_date:''}
    ]);
    
    const handleAddFields = (index) => {


        const values = [...inputFields];
        values.push({topic:'',description: '', max_seats: '',workshop_no:'',presenter_name: '', presenter_title: '', presenter_organization:'' , image: '', key: '', start_date:'', end_date:''});

        let error = false


        if(inputFields[index].topic === '' || inputFields[index].max_seats=== '' ||
           inputFields[index].presenter_name=== '' || inputFields[index].presenter_title=== '' || inputFields[index].presenter_organization===''
        )
        {
            error = true
        }else{
            setInputFields(values);  
        }


        if(inputFields[index].topic === ''){
            setTopicErr(true)
            setTopicErrInd(index)
        }else{
            setTopicErr(false)
        }

        if(inputFields[index].max_seats === ''){
            setSeatErr(true)
            setSeatErrInd(index)
        }else{
            setSeatErr(false)
        }

        if(inputFields[index].workshop_no === ''){
            setWnoErr(true)
            setWnoErrInd(index)
        }else{
            setWnoErr(false)
        }

        if(inputFields[index].presenter_name === ''){
            setPnameErr(true)
            setPnameErrInd(index)
        }else{
            setPnameErr(false)
        }

        if(inputFields[index].presenter_title === ''){
            setPtitleErr(true)
            setPtitleErrInd(index)
        }else{
            setPtitleErr(false)
        }

        if(inputFields[index].presenter_organization === ''){
            setPorgErr(true)
            setPorgErrInd(index)
        }else{
            setPorgErr(false)
        }
        

    };


    const handleSubmit = e => {
        e.preventDefault();
    };


    const handleInputChange = (index, event) => {

        const values = [...inputFields];



        // values[index].description = event

        console.log("event", values[index])


        if(event.target)
        {
            if (event.target.name === "topic") {
                values[index].topic = event.target.value;
            }else if(event.target.name === "max_seats"){
                values[index].max_seats = event.target.value;
            }else if(event.target.name === "presenter_name"){
                values[index].presenter_name = event.target.value;
            }else if(event.target.name === "presenter_title"){
                values[index].presenter_title = event.target.value;
            }else if(event.target.name === "presenter_organization"){
                values[index].presenter_organization = event.target.value;
            }
        }else{
            values[index].description = event;
        }

        setInputFields(values);
    };

    const handleRemoveFields = index => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };


    const [step, setStep] = useState(0);
    const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
    };
    
    
    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/workshop")
        
    }


    const {wid, sid} = useParams();

    const WorkshopMultipleAdd = () => {

        let inLength = inputFields.length - 1


        if(inputFields[inLength].topic === ''){
            setTopicErr(true)
            setTopicErrInd(inLength)
        }else{
            setTopicErr(false)
        }
        if(inputFields[inLength].max_seats === ''){
            setSeatErr(true)
            setSeatErrInd(inLength)
        }else{
            setSeatErr(false)
        }
        if(inputFields[inLength].presenter_name === ''){
            setPnameErr(true)
            setPnameErrInd(inLength)
        }else{
            setPnameErr(false)
        }
        if(inputFields[inLength].presenter_title === ''){
            setPtitleErr(true)
            setPtitleErrInd(inLength)
        }else{
            setPtitleErr(false)
        }
        if(inputFields[inLength].presenter_organization === ''){
            setPorgErr(true)
            setPorgErrInd(inLength)
        }else{
            setPorgErr(false)
        }




        if(inputFields[inLength].topic === '' || inputFields[inLength].max_seats=== '' || inputFields[inLength].presenter_name=== '' || inputFields[inLength].presenter_title=== '' || inputFields[inLength].presenter_organization==='')
        {

        }else{
            

        // setLoading(true)

            if(editable !== 'done'){
                alert('Done after submit')
            }else{

                let token = "Bearer "+localStorage.getItem('token');
                const data = {
                    workshops:inputFields
                }

            
            const instance = axios.create({

                baseURL: WorkshopListURL+"/multiple/"+wid+"/"+sid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
                        
            instance.post('',data).then((response) =>{
    

                message.success(inputFields.length === 1?'Workshop created successfully':'Workshops created successfully')

                navigate("/workshop/session/"+wid+"/"+sid)

            }).catch((error) =>{

                console.log("123456", error)
            });

        }

        }

    }


    const editButton =(index)=>{

        setEditable(index);
        setEditableIndex(index)   

    }





    const doneButton =(index)=>{


        let error = false

        if(inputFields[index].topic === '' || inputFields[index].max_seats=== '' || inputFields[index].presenter_name=== '' || inputFields[index].presenter_title=== '' || inputFields[index].presenter_organization==='')
        {
            error = true
        }else{
            setEditable('done');
            setEditableIndex('')
        }
        if(inputFields[index].topic === ''){
            setTopicErr(true)
            setTopicErrInd(index)
        }else{
            setTopicErr(false)
        }
        if(inputFields[index].max_seats === ''){
            setSeatErr(true)
            setSeatErrInd(index)
        }else{
            setSeatErr(false)
        }
        if(inputFields[index].presenter_name === ''){
            setPnameErr(true)
            setPnameErrInd(index)
        }else{
            setPnameErr(false)
        }
        if(inputFields[index].presenter_title === ''){
            setPtitleErr(true)
            setPtitleErrInd(index)
        }else{
            setPtitleErr(false)
        }
        if(inputFields[index].presenter_organization === ''){
            setPorgErr(true)
            setPorgErrInd(index)
        }else{
            setPorgErr(false)
        }

    }








    return(
        <Fragment>


        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                <div className="page-title-wrpr">
                    <div className="page-title-left-column">   
                        <h2 className="page-title">Add Workshops</h2>
                    </div>

                    <div class="page-rightside-action-column">
                        <button onClick={() => handleAddFields(inputFields.length - 1)}  data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add Workshop</span></button>
                    </div>
   
                    
                </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/workshop/session/"+wid+"/"+sid}>Workshop</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Workshop</li>
                        </ol>
                    </nav>


                <Panel className="public_label">


                <div class="main">
                <ul class="cards-session">

                {inputFields.map((inputField, index) => (

                    <li class="cards_item">
                    <div class="card-session">

                                <Panel className="public_label" header={
                                    <div className="row">
                                        <p className="col-md-9" 
                                            style={{color:'#000',  borderRadius:'10px', padding:'10px', width:'100%', fontSize:'14px'}}
                                        >Workshop  {(index+1)}</p>

                                        {inputFields.length - index === 1?null:
                                            <div className="col-md-3">
                                                {editable !== index?
                                                <button onClick={()=>{editButton(index)}}
                                                style={{background: '#144A98', color:'#fff',  borderRadius:'10px', padding:'10px', width:'100%', fontSize:'14px'}}
                                                >
                                                    Edit
                                                </button>:
                                                <button onClick={()=>{doneButton(index)}}
                                                style={{background: '#144A98', color:'#fff',  borderRadius:'10px', padding:'10px', width:'100%', fontSize:'14px'}}
                                                >
                                                    Done
                                                </button>}
                                            </div>
                                        }

                                    </div>
                                    } style={{padding:'5px', paddingTop:'20px', paddingBottom:'20px'}}>
                                    <form className="needs-validation" noValidate>
                                    <div className="form-wrpr">
                                        <div className="cards formcard medium">
                                        <div className="cards-body" >
                                                <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-12"  style={{marginTop:'10px'}}>
                                                    <label>Workshop Topic</label>  
                                                        <input 
                                                            disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                                                            placeholder="Workshop Topic" 
                                                        className='form-control public_input'
                                                        id="topic"
                                                        name="topic"
                                                        value={inputField.topic}
                                                        onChange={event => {handleInputChange(index, event)}}/>

                                                        {topicErr && topicErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter topic</p>:null}
                                                    </div>
                                                    <div className="col-md-12"  style={{marginTop:'20px'}}>
                                                    <label>Description</label>  
                                                        <RichTextEditor
                                                            id="description"
                                                            name="description"
                                                            value={inputField.description}
                                                            onChange={event => {handleInputChange(index, event)}}
                                                        />
                                                    </div>


                                                    <DatePickerss indexValue={index} inputField={inputField} />



                                                    <div className="col-md-6"  style={{marginTop:'20px'}}>
                                                    <label>Maximum Seats</label>  
                                                        <input 
                                                            disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                                                            placeholder="Maximum Seats" 
                                                            className='form-control public_input'
                                                            id="max_seats"
                                                            name="max_seats"
                                                            value={inputField.max_seats}
                                                            onChange={event => {handleInputChange(index, event)}}/>
                                                        {seatErr && seatErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter maximum seats</p>:null}

                                                    </div>


                                                    <div className="col-md-6"  style={{marginTop:'20px'}}>
                                                    <label>Presenter Name</label>  
                                                        <input 
                                                            disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                                                            placeholder="Presenter Name" 
                                                            className='form-control public_input'
                                                            id="presenter_name"
                                                            name="presenter_name"
                                                            value={inputField.presenter_name}
                                                            onChange={event => {handleInputChange(index, event)}}/>
                                                        {pnameErr && pnameErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter presenter name</p>:null}

                                                    </div>

                                                    <div className="col-md-6"  style={{marginTop:'20px'}}>
                                                    <label>Presenter Title</label>  
                                                        <input
                                                            disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                                                            placeholder="Presenter Title" 
                                                            className='form-control public_input'
                                                            id="presenter_title"
                                                            name="presenter_title"
                                                            value={inputField.presenter_title}
                                                            onChange={event => {handleInputChange(index, event)}}/>
                                                        {ptitleErr && ptitleErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter presenter title</p>:null}

                                                    </div>

                                                    <div className="col-md-6"  style={{marginTop:'20px'}}>
                                                    <label>Presenter Organization</label>  
                                                        <input 
                                                            disabled={(inputFields.length - index === 1 && inputFields.length) || editableIndex === index ?false:true} 
                                                            placeholder="Presenter Organization" 
                                                            className='form-control public_input'
                                                            id="presenter_organization"
                                                            name="presenter_organization"
                                                            value={inputField.presenter_organization}
                                                            onChange={event => {handleInputChange(index, event)}}/>
                                                        {porgErr && porgErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter presenter organization</p>:null}

                                                    </div>

                                                    <ImageUpload setDisabled={setDisabled} indexValue={index} inputField={inputField} />

                                                    <div className="col-md-6"  style={{marginTop:'30px'}} />

                                                    {/* <div className="col-md-6"  style={{marginTop:'30px'}}>


                                                    <button
                                                        style={{background: '#fff',border:'2px solid #144A98', color:'#144A98',  borderRadius:'10px', padding:'10px', width:'100%', fontSize:'14px'}}
                                                        // className="btn btn-link"
                                                        type="button"
                                                        disabled={index === 0}
                                                        onClick={() => handleRemoveFields(index)}
                                                    >
                                                        <i className="icon-times" style={{fontSize:'25px'}}></i>
                                                    </button>

                                                    </div> */}
{/* 
                                                    <div className="col-md-6"  style={{marginTop:'30px'}}>


                                                    {inputFields.length - index === 1?
                                                    <button
                                                        style={{background:'#144A98',border:'2px solid #144A98', color:'#fff',  borderRadius:'10px', padding:'10px', width:'100%', fontSize:'14px'}}
                                                        // className="btn btn-link"
                                                        type="button"
                                                        onClick={() => handleAddFields(index)}
                                                    >
                                                        <i className=" icon-plus3" style={{fontSize:'25px'}}></i>
                                                    </button>:null}

                                                    </div> */}
                                    


                                    <div className="col-md-6"  style={{marginTop:'30px'}}>

                                        <div className="page-rightside-action-column">

                                            {inputFields.length - index === 1?

                                            <button
                                                style={{background:'red', color:'#fff',  borderRadius:'10px', padding:'15px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                                type="button"
                                                className='addbtnitem-link text-anchor'
                                                disabled={index === 0}
                                                onClick={() => handleRemoveFields(index)}
                                            >
                                            <i className="icon-times" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Remove Workshop</span>
                                            </button>:null}

                                        </div>

                                        </div>



                                        <div className="col-md-6"  style={{marginTop:'30px'}}>

                                        <div className="page-rightside-action-column">

                                            {inputFields.length - index === 1?

                                            <button
                                                style={{background:'#4077cf', color:'#fff',  borderRadius:'10px', padding:'15px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                                type="button"
                                                className='addbtnitem-link text-anchor'
                                                onClick={() => handleAddFields(index)}
                                            >
                                            <i class="icon-add" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Add Workshop</span>
                                            </button>:null}

                                        </div>

                                        </div>


                                    
                                                </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        </form>

                                        </Panel>  

                                    </div>
                                    </li>

                                ))}




                            </ul>
                        </div>


                        <div style={{marginTop:'30px', textAlign:'center'}}>
                                <button onClick={()=>{navigate('/workshop/session/'+wid+"/"+sid)}} 
                                style={{backgroundColor:'#fff', 
                                width:'40%',
                                border:'2px solid #144A98', 
                                padding:'10px', 
                                paddingLeft:'50px', 
                                paddingRight:'50px',
                                margin:'10px',
                                borderRadius:'10px',
                                fontSize:'16px',
                                color:'#144A98',
                            }}>Cancel</button>
                                <button onClick={WorkshopMultipleAdd} 
                                disabled={disabled}
                                style={{backgroundColor:'#144A98', 
                                width:'40%',
                                border:'2px solid #144A98', 
                                padding:'10px', 
                                paddingLeft:'50px', 
                                paddingRight:'50px',
                                margin:'10px',
                                borderRadius:'10px',
                                fontSize:'16px',
                                color:'#fff',
                            }}>{inputFields.length === 1?'Create Workshop':'Create Workshops'}</button>
                        </div>
                    </Panel>


                </div>
            </aside>
        </div>

           
    </Fragment>
    )
}

export default MultipleWorkshopCreate;